<template>
  <v-card>
    <v-divider></v-divider>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <message :messages="messages"></message>
          </v-flex>
          <v-flex xs6 v-if="!isNew">
            <v-subheader class="queryLabel">{{ labels.busCls }}</v-subheader>
            <div class="queryValue">{{ busClsClseForm.busCls }}</div>
          </v-flex>
          <v-flex xs6 v-else>
            <v-autocomplete
              :label="labels.busCls"
              v-model="busClsClseForm.busCls"
              :items="busClsList"
              item-text="label"
              item-value="value"
              data-vv-name="busCls"
              :data-vv-as="labels.busCls"
              :error-messages="errors.collect('busCls')"
              v-validate="'required'"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12>
            <v-subheader class="queryLabel">{{ labels.clseTitle }}</v-subheader>
            <div class="queryValue">{{ clseTitle }}</div>
          </v-flex>
          <v-flex xs12>
            <v-checkbox :disabled="isQuery" :label="labels.defClse" v-model="busClsClseForm.defClse"></v-checkbox>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
            <div class="queryValue">{{ createdBy }}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
            <div class="queryValue">{{ formatDate(createdDate) }}</div>
          </v-flex>
          <v-flex xs6 v-if="!isNew">
            <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
            <div class="queryValue">{{ modifiedBy }}</div>
          </v-flex>
          <v-flex xs6 v-if="!isNew">
            <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
            <div class="queryValue">{{ formatDate(modifiedDate) }}</div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-flex xs12 v-if="!isQuery">
      <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSave">
        {{ isNew ? 'Save Clause' : 'Save Clause' }}
        <v-icon right>{{ isNew ? 'mdi-content-save' : 'mdi-content-save' }}</v-icon>
      </v-btn>
    </v-flex>
  </v-card>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'

export default {
  data() {
    return {
      labels: {
        busCls: 'Business Class*',
        clseTitle: 'Clause Title',
        defClse: 'Default Clause',
        createdBy: 'Created by',
        createdDate: 'Created Date',
        modifiedBy: 'Modified by',
        modifiedDate: 'Modified Date'
      },
      busClsClseForm: {
        clseNo: null,
        busCls: null,
        defClse: false
      },
      clseTitle: null,
      submitting: false,
      busClsList: [],
      createdBy: undefined,
      createdDate: undefined,
      modifiedBy: undefined,
      modifiedDate: undefined
    }
  },
  watch: {
    ids: {
      handler(newValue) {
        this.doClearForm()
        this.getBusClsList()
        if (this.isNew) {
          this.busClsClseForm.clseNo = this.ids.clseNo
          this.clseTitle = this.ids.clseTitle
          this.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
          this.createdDate = new Date()
        } else if (newValue.tranMode !== null) {
          this.doInit()
        }
      },
      deep: true
    }
  },
  mounted() {
    this.doInit()
  },
  computed: {
    clsemenu() {
      return this.$store.state.docFormatParam.menu
    },
    isReview() {
      return this.ids.tranMode === 'Review'
    },
    isQuery() {
      return this.ids.tranMode === 'Query'
    },
    isNew() {
      return this.ids.tranMode === 'New'
    }
  },
  methods: {
    async doInit() {
      this.busClsClseForm.clseNo = this.ids.clseNo
      this.busClsClseForm.busCls = this.ids.busCls
      this.clseTitle = this.ids.clseTitle
      if (!this.isNew) {
        const apiURI = this.clsemenu.getBusClsClse
        if (apiURI) {
          try {
            const expand = {
              clseNo: this.ids.clseNo,
              busCls: this.ids.busCls
            }
            const result = await this.$http.get(expandURI(apiURI, expand))
            const { data } = result.data
            if (data) {
              this.busClsClseForm.defClse = data.busClsClause.defClse
              this.createdDate = data.createdDate
              this.modifiedDate = data.modifiedDate
              this.createdBy = data.createdBy
              this.modifiedBy = data.modifiedBy
            } else {
              this.errorMessage('Fail to load Data from server. Please try to refresh page')
            }
          } catch (error) {
            const { data } = error.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          }
        } else {
          this.errorMessage('The request failed because it is trying to execute an invalid API url.')
        }
      }
    },
    async getBusClsList() {
      const apiURI = this.clsemenu.busClsList
      try {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.busClsList = data
        }
      } catch (err) {
        throw err
      }
    },
    async doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.isNew) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.clsemenu.createBusClsClse
      if (apiURI) {
        try {
          const result = await this.$http.post(apiURI, this.busClsClseForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$emit('resetTab')
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.notify(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    formatDate(xDate) {
      if (xDate === null) {
        return undefined
      } else {
        return formatDisplayDate(xDate)
      }
    },
    async doUpdate() {
      const apiURI = this.clsemenu.updateBusClsClse
      if (apiURI) {
        try {
          const result = await this.$http.put(apiURI, this.busClsClseForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$emit('resetTab')
          }
        } catch (error) {
          const { data } = error.message
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doClearForm() {
      this.resetValidator()
      this.resetMessages()
      this.busClsClseForm.clseNo = this.ids.clseNo
      this.busClsClseForm.busCls = null
      this.busClsClseForm.defClse = false
      this.createdDate = null
      this.modifiedDate = null
      this.createdBy = null
      this.modifiedBy = null
    }
  },
  mixins: [MessageMixin],
  props: {
    ids: {
      type: Object,
      default() {
        return {
          tranMode: null
        }
      }
    }
  }
}
</script>

<style>
</style>
